import type { DeskLayout } from '../models/desk-layout.model';

export const P34_DESKS: DeskLayout[] = [
  { name: 'M18', x: 62.8218, y: 120, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1363, liftDesk: false },
  { name: 'M20', x: 14, y: 120, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1365 },
  { name: 'M17', x: 62.8218, y: 66, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1362 },
  { name: 'M19', x: 14, y: 66, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1364 },
  { name: 'M14', x: 205.822, y: 120, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1359 },
  { name: 'M16', x: 157, y: 120, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1361 },
  { name: 'M13', x: 205.822, y: 66, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1358 },
  { name: 'M15', x: 157, y: 66, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1360 },

  { name: 'M37', x: 777.822, y: 259, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1382 },
  { name: 'M36', x: 729, y: 259, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1381 },
  { name: 'M38', x: 777.822, y: 205, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1389 },
  { name: 'M35', x: 729, y: 205, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1380 },

  { name: 'M60', x: 1493.82, y: 455, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1405 },
  { name: 'M58', x: 1445, y: 455, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1403 },
  { name: 'M59', x: 1493.82, y: 401, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1404 },
  { name: 'M57', x: 1445, y: 401, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1402 },

  { name: 'M64', x: 1637.82, y: 455, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1409 },
  { name: 'M62', x: 1589, y: 455, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1407 },
  { name: 'M63', x: 1637.82, y: 401, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1408 },
  { name: 'M61', x: 1589, y: 401, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1406 },

  { name: 'M68', x: 1789.82, y: 455, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1413 },
  { name: 'M66', x: 1741, y: 455, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1411 },
  { name: 'M67', x: 1789.82, y: 401, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1412 },
  { name: 'M65', x: 1741, y: 401, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1410 },

  { name: 'M72', x: 1493.82, y: 588, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1417 },
  { name: 'M70', x: 1445, y: 588, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1415 },
  { name: 'M71', x: 1493.82, y: 534, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1416 },
  { name: 'M69', x: 1445, y: 534, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1414 },

  { name: 'M76', x: 1637.82, y: 588, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1421 },
  { name: 'M74', x: 1589, y: 588, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1419 },
  { name: 'M75', x: 1637.82, y: 534, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1420 },
  { name: 'M73', x: 1589, y: 534, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1418 },

  { name: 'M80', x: 1789.82, y: 588, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1425 },
  { name: 'M78', x: 1741, y: 588, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1423 },
  { name: 'M79', x: 1789.82, y: 534, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1424 },
  { name: 'M77', x: 1741, y: 534, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1422 },

  { name: 'M34', x: 634.822, y: 259, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1379 },
  { name: 'M32', x: 586, y: 259, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1377 },
  { name: 'M33', x: 634.822, y: 205, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1378 },
  { name: 'M31', x: 586, y: 205, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1376 },

  { name: 'M30', x: 491.822, y: 259, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1375 },
  { name: 'M28', x: 443, y: 259, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1373 },
  { name: 'M29', x: 491.822, y: 205, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1374 },
  { name: 'M27', x: 443, y: 205, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1372 },

  { name: 'M26', x: 348.822, y: 260, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1371 },
  { name: 'M24', x: 300, y: 260, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1369 },
  { name: 'M25', x: 348.822, y: 206, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1370 },
  { name: 'M23', x: 300, y: 206, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1368 },

  { name: 'M44', x: 291.822, y: 603, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1389 },
  { name: 'M42', x: 243, y: 603, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1387 },
  { name: 'M43', x: 291.822, y: 549, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1388 },
  { name: 'M41', x: 243, y: 549, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1386 },

  { name: 'M56', x: 717.822, y: 603, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1401 },
  { name: 'M54', x: 669, y: 603, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1399 },
  { name: 'M55', x: 717.822, y: 549, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1400 },
  { name: 'M53', x: 669, y: 549, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1398 },

  { name: 'M52', x: 575.822, y: 603, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1397 },
  { name: 'M50', x: 527, y: 603, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1395 },
  { name: 'M51', x: 575.822, y: 549, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1396 },
  { name: 'M49', x: 527, y: 549, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1394 },

  { name: 'M48', x: 433.822, y: 603, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1393 },
  { name: 'M46', x: 385, y: 603, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1391 },
  { name: 'M47', x: 433.822, y: 549, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1392 },
  { name: 'M45', x: 385, y: 549, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1390 },

  { name: 'M10', x: 348.822, y: 120, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1355 },
  { name: 'M12', x: 300, y: 120, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1357 },
  { name: 'M9', x: 348.822, y: 66, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1354 },
  { name: 'M11', x: 300, y: 66, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1356 },

  { name: 'M6', x: 491.822, y: 120, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1351 },
  { name: 'M8', x: 443, y: 120, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1353 },
  { name: 'M5', x: 491.822, y: 66, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1350 },
  { name: 'M7', x: 443, y: 66, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1352 },

  { name: 'M2', x: 634.822, y: 120, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1347 },
  { name: 'M4', x: 586, y: 120, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1349 },
  { name: 'M1', x: 634.822, y: 66, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1346 },
  { name: 'M3', x: 586, y: 66, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1348 },

  { name: 'M21', x: 62.8218, y: 250.899, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1366 },
  { name: 'M22', x: 62.8218, y: 304.899, w: 43.8218, h: 47.8448, rx: 9, reservationId: 1367 }
];